import styled from "@emotion/styled";

const Padding = styled.div<{ p: 4 | 8 | 12 | 16 | 24 | 32 | 64 }>`
  padding: ${(props) => props.p}px;
`;

export default Padding;
